import qs from 'qs';
import client from './client';

const salesCostUrl = '/api/v1/settlement/expense';

// 판매관리비 통계 

//판매관리비 계정 리스트 가져오기
export const getSalesCostsStaticTotal = (year) => {
//  const queryString = qs.stringify(searchData);
  return client.get(`${salesCostUrl}/static/info/${year}`);
};

export const getSalesCostsStaticEmpTotal = (year, emp) => {
  //  const queryString = qs.stringify(searchData);
    return client.get(`${salesCostUrl}/static/info/user/${year}/${emp}`);
  };

//판매관리비 계정 리스트 가져오기
export const getSalesCosts = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${salesCostUrl}/list?${queryString}`);
};

export const addSalesCost = (dataToSubmit) => {
  return client.post(`${salesCostUrl}/info`, dataToSubmit);
};

export const editSalesCost = (dataToSubmit) => {
  return client.put(
    `${salesCostUrl}/info/${dataToSubmit.scUuid}`,
    dataToSubmit,
  );
};

//판매관리비 삭제
export const deleteSalesCost = (id) =>
  client.delete(`${salesCostUrl}/info/${id}`);

// 엑셀 업로드
export const uploadExl = (formData) => {
  return client.post(`${salesCostUrl}/info/upload`, formData, {
    header: { 'Content-type': 'multipart/form-data' },
  });
};
 
//판매관리비 전체체 엑셀 다운로드
export const downloadExl = ({ year }) => {
  return client.get(`${salesCostUrl}/info/${year}/download `, {
    responseType: 'arraybuffer',
  });
};

//판매관리비 계정 리스트 가져오기_ 새로 만든거.
export const getSalesCostsStaticTotalDeptNew = () => {
//  const queryString = qs.stringify(searchData);
  return client.get(`${salesCostUrl}/static/info/dept`);
};

//판매관리비 계정 리스트 가져오기_ 새로 만든거.
export const getSalesCostsStaticTotalNew = (year, month) => {
//  const queryString = qs.stringify(searchData);
  return client.get(`${salesCostUrl}/static/info/${year}/${month}`);
};

// 저장 (POST) - 연도, 월을 경로로 받고 데이터를 Body로 보낼 때
export const saveSalesCostsStaticTotalNew = (year, month, dataList) => {
  return client.post(`${salesCostUrl}/static/info/${year}/${month}`, dataList);
};

export const getSalesCostsStaticTotalViewNew = (year) => {
//  const queryString = qs.stringify(searchData);
  return client.get(`${salesCostUrl}/static/info/view/${year}`);
};

